import React from "react";
import { HiOutlineUserAdd } from "react-icons/hi";
import { useTranslation } from "react-i18next";
import OptionToggleRow from "./OptionToggleRow";

interface UserRegistrationToggleProps {
  enabled: boolean;
  onChange: (enabled: boolean) => void;
  title?: string;
  description?: string;
}

const UserRegistrationToggle: React.FC<UserRegistrationToggleProps> = ({
  enabled,
  onChange,
  title,
  description,
}) => {
  const { t } = useTranslation();

  return (
    <OptionToggleRow
      icon={HiOutlineUserAdd}
      iconClassName="text-blue-600"
      title={title ?? t("businessCardPage.optionsTab.userRegistrationTitle")}
      description={
        description ??
        t("permissions.businessCard.userRegistration.enableGloballyDescription")
      }
      enabled={enabled}
      onChange={onChange}
    />
  );
};

export default UserRegistrationToggle;
